import { makeStyles } from '@material-ui/core/styles';
import { variables } from '../../styles';

export const useStyles = makeStyles((theme) => ({
  headerSpace: {
    flexGrow: 1,
    boxShadow: 'none',
  },
  header: {
    backgroundColor: 'white',
    paddingInlineEnd: 56,
    paddingInlineStart: 56,
    position: 'fixed',
    boxShadow: `none`,
    zIndex: 1000,
    '@media (max-width: 1180px)': {
      display: 'none',
    },
    width: 'calc(100% - 320px)',
  },
  title: {
    fontWeight: 600,
    fontSize: 32,
    color: variables.richBlack,
  },
  mobileHeader: {
    '@media (min-width: 1181px)': {
      display: 'none',
    },
  },
  mobileToolbar: {
    height: 74,
    width: '100%',
    justifyContent: 'space-between',
  },
  appBar: {
    display: 'flex',
    background: variables.background,
    color: variables.black,
    width: '100%',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxShadow: 'none',
    alignItems: 'center',
  },
  appBarShift: {
    display: 'flex',
    width: '100%',
    boxShadow: 'none',
    height: 119,
    backgroundColor: variables.white,
  },
  toolbar: {
    height: '100%',
    padding: 0,
  },
  languageSelect: {
    '& svg': {
      top: 'auto',
    },
  },
  languageItem: {
    display: 'flex',
    color: variables.black50,
    alignContent: 'center',
    textTransform: 'capitalize',
  },
  languageSelectedItem: {
    height: 14,
    marginInlineEnd: 5,
  },
  languageSelectItem: {
    height: 18,
    marginInlineEnd: 5,
  },
  logo: {
    margin: 'auto',
    textAlign: 'center',
    marginTop: 40,

    '@media (max-width: 1024px)': {
      marginTop: 'auto',
    },
  },
  logoImg: {
    width: 200,
    '@media (max-width: 1024px)': {
      width: 84,
    },
  },
  unathorizedHeader: {
    background: variables.white,
    boxShadow: `none`,
    paddingLeft: 75,
    paddingRight: 75,
  },
  btn: {
    '& img': {
      width: 14,
    },
  },
}));
